
import { Layout, Model, IJsonModel } from 'flexlayout-react';
import { DocumentData } from '../../context/DocumentDataProvider';
import { findReactFlowTabset } from './FindReactFlowTabset';

// Función para agregar una nueva figura
export const handleAddPlot = (setDocumentData: React.Dispatch<React.SetStateAction<DocumentData>>,
    setPlots: React.Dispatch<React.SetStateAction<Map<string, any>>>,
    layoutModel: Model,
    setLayoutModel: React.Dispatch<React.SetStateAction<Model>>,
    uniqueId: string,
    plotName: string,
) => {
    // 1) Actualizamos el state de `plots` de forma atómica y obtenemos el nombre/id nuevo
    let newPlotName = '';
    const updatedMap = setPlots(prev => {
        const updated = new Map(prev);
        const newIndex = (prev?.size || 0) + 1;
        newPlotName = plotName || `Plot ${newIndex}`;
        const newPlot = {
            id: uniqueId,
            data: [{
                x: [1, 2, 3, 4],
                y: [Math.random() * 10, Math.random() * 10, Math.random() * 10, Math.random() * 10],
                type: 'scatter',
                name: newPlotName,
            }],
            layout: {
                title: { text: 'Data Labels Hover' },
                yaxis: { title: { text: 'Y axis (m/s)' } },
                xaxis: { title: { text: 'X axis (m/s)' } },
            },
        };
        updated.set(uniqueId, newPlot);
        return updated;
    });

    // Note: setPlots above is asynchronous; we can't rely on `plots` immediately after.
    // Instead, read the new map via the return value of setPlots is not provided by React,
    // so we reconstruct a copy from the previous Map + new entry to pass to documentData.
    // To keep things simple and safe, build a serializable copy using the current layout and
    // the fresh newPlotName created above.

    // 2) Update documentData using the new map contents (serialize to a plain object if needed)
    // setDocumentData(prev => {
    //     const copyMap = new Map(prev.plots || []);
    //     // Ensure we add the newly created plot name if it wasn't present on documentData
    //     if (!copyMap.has(newPlotName)) {
    //         // Try to pull the plot from the local `plots` state (best-effort)
    //         // If not available yet, create a minimal placeholder matching what we added above.
    //         const placeholder = {
    //             id: Number(newPlotName.replace('Plot ', '')) || (copyMap.size + 1),
    //             data: [{ x: [1, 2, 3, 4], y: [0, 0, 0, 0], type: 'scatter', name: newPlotName }],
    //             layout: { title: { text: 'Data Labels Hover' } },
    //         };
    //         copyMap.set(newPlotName, placeholder);
    //     }

    //     return {
    //         ...prev,
    //         layoutConfig: layoutModel.toJson(),
    //         plots: copyMap,
    //     };
    // });

    // 3) Add a new tab to the layout JSON. NOTE: recreating the Model with Model.fromJson
    // will remount tabs and may reset internal tab state. If you need to preserve internal
    // state inside tabs, prefer using the model's action API (doAction/addNode) if available.
    setLayoutModel(prevModel => {
        const json = prevModel.toJson();
        const tabset = findReactFlowTabset(json.layout);
        if (tabset) {
            const newTab = {
                id: uniqueId,
                type: 'tab',
                name: newPlotName,
                component: 'PlotlyTab',
                config: {},
                enableClose: false,
                enableDrag: true,
                enableRename: true,
                children: [],
                icon: 'chart-dots-2.svg',
            };
            tabset.children.push(newTab);
        } else {
            console.warn('No tabset found in layout JSON to add the plot tab.');
        }

        // Recreating the model from JSON will remount the Layout children. This is the
        // simplest cross-version approach; if you want to avoid remounts, replace this
        // with the Model action API (model.doAction) to add a node dynamically.
        return Model.fromJson(json);
    });
};